import { useCallback, type ReactNode } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { ThreadFileStateProvider, useFileStates, type ThreadFileState } from "../chat/fileState";
import { useThreadId } from "../chat/useThreadId";
import type { AgentState } from "../store/agentSlice";
import { selectFiledFiles } from "../store/selectors";

/**
 * Tells the chat's attachment chips which of its thread's files are filed (they turn green): those
 * the store knows of, added to whatever an outer provider says.
 */
export function FiledFilesProvider({ children }: { children: ReactNode }) {
  const outer = useFileStates();
  const threadId = useThreadId();
  const filed = useSelector(
    (state: { agent: AgentState }) => selectFiledFiles(state, threadId),
    shallowEqual
  );
  const state = useCallback(
    (threadFileId: number): ThreadFileState =>
      filed.includes(threadFileId) ? "filed" : outer(threadFileId),
    [outer, filed]
  );
  return <ThreadFileStateProvider state={state}>{children}</ThreadFileStateProvider>;
}
